import { active_project }              from 'state/store.global'
import { vis_filter, vis_detail }      from 'state/store.global'
import { vis_desktop_nav }             from 'state/store.global'
import { useAtom, useGet }             from 'state/jotai'
import { Content, Root }               from './Layout.style'
import { DualMenu }                    from 'components/DualMenu/DualMenu'
import { TopMenu }                     from 'components/TopMenu/TopMenu'
import { useLocation }                 from 'react-router-dom'
import { useBreak }                    from 'hooks/useBreak'
import { useEffect, useRef, useState } from 'react'
import useUnitPage                     from 'components/Unit/useUnitPage'
import { Scrollbar }                   from 'react-scrollbars-custom'
import { isIframeMode }                from 'logging/logging'
import { useToggle }                   from 'hooks/useToggle'

export const Layout = ({ children }) => {
  const [viewportHeight, setViewportHeight]              = useState(0);
  const here                                             = useLocation().pathname
  const isDesktop                                        = useBreak('md_up')
  const { Navigation, DrawersLeft, DrawersRight, Views } = children

  const { overlayState: { filter, detail} } = useToggle();
  
  const pin            = useGet(active_project).pin
  const left           = filter
  const right          = detail
  const nav            = useGet(vis_desktop_nav)
  const activeURL      = ["list", "compare", "unit", "isometry", "gallery", "downloads", "favorites"]
  const activeURLindex = activeURL.findIndex(i => here.includes(i))
  const iFrameEnabled  = isIframeMode()
  const style          = {
      "isometry": {
        marginTop: iFrameEnabled
    ? (isDesktop ? (pin > 0 ? "0px" : "0px") : "0px") 
            :  "72px",
    position: !isDesktop ? "fixed"                                     : "unset",
    top     : "0",
    left    : "0",
    width   : "100%",
    height  : isDesktop ? pin > 0 ? `calc(${viewportHeight}px - ${iFrameEnabled ? '66' : '166'}px)`: `calc(${viewportHeight}px - ${iFrameEnabled ? '0' : '70'}px)`: `calc(${viewportHeight}px - ${iFrameEnabled ? '0' : "80"}px)`
      },
      "list": {
        marginTop    :iFrameEnabled && isDesktop ?  "0px" :isDesktop ? "72px"              : iFrameEnabled ? "0px" : "142px",
        height       : isDesktop && iFrameEnabled ? ("calc(100% - 75px)") : isDesktop ? "calc(100% - 156px)": right ? "500px": "calc(100% - 172px)",
        paddingBottom: isDesktop ? ''                  : "89px",
        overflow     : right ? 'hidden'                : 'auto',
      },
      "unit": {
        marginTop: isDesktop && iFrameEnabled ? "0px" :isDesktop ?  "72px"             : iFrameEnabled ? "0" : "69px",
        height   : isDesktop && iFrameEnabled ?("calc(100% - 0px)") : isDesktop ? "calc(100% - 72px)": "calc(100% - 69px)",
      },
      "compare": {
        marginTop: iFrameEnabled ? (isDesktop ? "120px" : "95px")                         : (isDesktop ? "210px" : "170px"),
        height   : iFrameEnabled ? (isDesktop ? "calc(100% - 125px)" : "calc(100% - 90px)"): (isDesktop ? "calc(100% - 200px)" : "calc(100% - 119px)"),
        overflow : "hidden"
      },
      "favorites": {
        marginTop: iFrameEnabled ? (isDesktop ? "16px" : "16px")                          : (isDesktop ? "119px" : "119px"),
        height   : iFrameEnabled ?(isDesktop ? "calc(100% - 24px)" : "calc(100% - 102px)"): (isDesktop ? "calc(100% - 119px)" : "calc(100% - 119px)"),
      },
      "gallery": {
        marginTop: isDesktop ? "125px"              : "125px",
        height   : isDesktop ? "calc(100vh - 125px)": "calc(100% - 125px)"
      },
      "downloads": {
        marginTop: isDesktop ? "135px"             : "119px",
        height   : isDesktop ? "calc(100% - 135px)": "calc(100% - 119px)"
      }
    }
  
  const rootStyle = {
    "isometry": {
      height   : !isDesktop ? '150vh': "100%",
      overflowY: "hidden"
    }
  }

  useEffect(() => {
      // Function to update the viewport height
    const updateViewportHeight = () => {
      setViewportHeight(window.innerHeight);
    };

      // Set the viewport height on load
    updateViewportHeight();

      // Add resize event listener
    window.addEventListener("resize", updateViewportHeight);

      // Cleanup the event listener on unmount
    return () => {
      window.removeEventListener("resize", updateViewportHeight);
    };
  }, []);
  return (
    <Root styles = {rootStyle[activeURL[activeURLindex]]}>
      { pin >= 0 && DrawersLeft.map(i => i) }
      { pin >= 0 && DrawersRight.map(i => i) }
      <Content path = {activeURL[activeURLindex]} left = {left} right = {right} nav = {nav} styles = {style[activeURL[activeURLindex]]}>
        { Views }
      </Content>
      {!iFrameEnabled && 
      <TopMenu  left = {left} right = {right} nav = {nav}/>
      }
      <DualMenu left = {left} right = {right} nav = {nav}/>
      { Navigation }
    </Root>
  )
}